var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.phase)?_c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"w-2 h-2 rounded-full mr-2",class:_vm.dotColor}),_c('div',[_vm._v(_vm._s(_vm.phase.name))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }